<div class="open-badge-dialog__header"
     mat-dialog-title>
    @if (data?.name) {
        <h1>{{ data?.name }}</h1>
    }
    <button mat-dialog-close
            [attr.aria-label]="'generic.close' | translate"
            [matTooltip]="'generic.close' | translate">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<mat-dialog-content class="open-badge-dialog__content">
    <div class="open-badge-dialog__media-content">
        @if (data?.badge) {
            <img [src]="data?.badge" alt=""/>
        }
        <dl>
            @if (data?.name) {
                <dt>{{ 'openbadge.name' | translate }}</dt>
                <dd class="subtitle">{{ data?.name }}</dd>
            }
            <dt>{{ 'openbadge.issuer' | translate }}</dt>
            <dd class="subtitle">{{ 'openbadge.issuer-value' | translate }}</dd>
        </dl>
        <div class="open-badge-dialog__button-container">
            <button (click)="downloadBadgeImage()">
                    <span>{{ 'generic.download' | translate }}</span>
            </button>
            <button (click)="downloadBadgeCertificate()">
                    <span>{{ 'generic.download_certificate' | translate }}</span>
            </button>
        </div>
    </div>
    <div class="open-badge-dialog__data-content">
        <dl>
            @if (data?.awardDetails?.username) {
                <dt>{{ 'openbadge.award-username' | translate }}</dt>
                <dd class="subtitle">{{ data?.awardDetails?.username }}</dd>
            }
            @if (data?.awardDetails?.issueDate) {
                <dt>{{ 'openbadge.award-issueDate' | translate }}</dt>
                <dd class="subtitle">{{ data?.awardDetails?.issueDate }}</dd>
            }
            @if (data?.description) {
                <dt>{{ 'openbadge.description' | translate }}</dt>
                <dd [innerHTML]="data?.description"></dd>
            }
            @if (data?.criteria) {
                <dt>{{ 'openbadge.criteria' | translate }}</dt>
                <dd [innerHTML]="data?.criteria"></dd>
            }
        </dl>
    </div>
</mat-dialog-content>

@if (!isGar) {
    <mat-dialog-actions class="open-badge-dialog__actions">
        <ul >
            <li>
                <mat-icon svgIcon="mail"></mat-icon>
                <a [href]="'openbadge.link1-href' | translate"
                    target="_blank">
                    <span>{{ 'openbadge.link1-text' | translate}}</span>
                    <mat-icon svgIcon="arrow_diag"></mat-icon>
                </a>
            </li>
            <li>
                <mat-icon svgIcon="world"></mat-icon>
                <a [href]="'openbadge.link2-href' | translate"
                    target="_blank">
                    <span>{{ 'openbadge.link2-text' | translate}}</span>
                    <mat-icon svgIcon="arrow_diag"></mat-icon>
                </a>
            </li>
            <li>
                <mat-icon svgIcon="information"></mat-icon>
                <a [href]="'openbadge.link3-href' | translate"
                    target="_blank">
                    <span>{{ 'openbadge.link3-text' | translate}}</span>
                    <mat-icon svgIcon="arrow_diag"></mat-icon>
                </a>
            </li>
        </ul>
    </mat-dialog-actions>
}